import { contentV1GetPresetDataSourcesOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetPresetDataSources = () => {
  const workspaceContext = useWorkspace();
  const workspace = workspaceContext.workspace;

  return useQuery({
    ...contentV1GetPresetDataSourcesOptions({
      ...defaultOptions(),
      path: { workspace },
    }),
    enabled: !!workspace,
  });
};
